import { render, staticRenderFns } from "./serviceprovider.vue?vue&type=template&id=e08706b6&scoped=true"
import script from "./serviceprovider.vue?vue&type=script&lang=js"
export * from "./serviceprovider.vue?vue&type=script&lang=js"
import style0 from "./serviceprovider.vue?vue&type=style&index=0&id=e08706b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08706b6",
  null
  
)

export default component.exports